import React, {useRef} from "react";
import useFontStore from "../stores/useFontStore";
import minimap from "../assets/images/map-small.png";
import styled from "@emotion/styled";
import {Flex} from "@adobe/react-spectrum";
//import {getRefRect} from "../utils/windowUtils";

const MinimapStyled = styled.div({
    position: "relative",
    width: "100px",
    height: "100px",
    background: `url(${minimap})`,
    border: "2px solid rgb(230, 230, 230)",
    transformOrigin: "left bottom"
})

const PinContainer = styled.div({
    position: "absolute",
    width: "10px",
    height: "10px",
    backgroundColor: "#CCCCCC80",
    border: "1px solid #33333380",
    borderRadius: "5px",
    opacity: "1",
    transition: "all 150ms linear"
});

const PinCenter = styled.div({
    position: "absolute",
    width: "1px",
    height: "1px",
    backgroundColor: "#333333",
    borderRadius: "0.5px",
    opacity: "1",
    left: "50%",
    top: "50%",
    transform: "translate(-0.5px, -0.5px)"
})

function Minimap() {

    const ref = useRef<HTMLDivElement>(null);

    const currFont = useFontStore(state => state.currFont);

    const onClick = (e: React.MouseEvent) => {
        //let rect = getRefRect(ref);
        //let x = e.clientX - rect.x;
        //let y = e.clientY - rect.y;
    }

    return (
        <Flex direction="column">
            {/*<p><strong>Minimap</strong></p>*/}
            <MinimapStyled ref={ref} onClick={onClick}>
                <PinContainer style={{transform: `translate(${currFont.x/2 - 5}px, ${currFont.y/2 - 5}px)`}}>
                    <PinCenter/>
                </PinContainer>
            </MinimapStyled>
        </Flex>
    );
}

export default Minimap;